import { useState } from 'react';
import {
  AMENITY_SPACES_CATEGORY,
  INDIVIDUAL_WORKSPACES_CATEGORY,
  MEETING_SPACES_CATEGORY,
  SUPPORT_SPACES_CATEGORY,
} from 'spw-constants';

export type VisibleCards = {
  projectOverview: boolean;
  keyDataPoints: boolean;
  spaceTypeAllocationIndividualWorkspacesUsf: boolean;
  spaceTypeAllocationSubtotalUsf: boolean;
  headcountUsf: boolean;
  seatCountUsf: boolean;
  deskSharingRatio: boolean;
  usfBreakdown: boolean;
  meetingSeatRatio: boolean;
  programSummaryReport: boolean;
  workpoints: boolean;
  seatCountUsfWithWorkpoints: boolean;
  deskSharingWithWorkpoints: boolean;
  alternativeWorkpointsBreakdown: boolean;
  categoryUsfAndSeatMix: Record<
    string,
    {
      usfAndSeatMix: boolean;
      usfMix: boolean;
      seatMix: boolean;
      usfMixAndRatios: boolean;
      ratios: boolean;
    }
  >;
};

export const useVisibleCards = () => {
  const [visibleCards, setVisibleCards] = useState({
    projectOverview: true,
    keyDataPoints: true,
    spaceTypeAllocationIndividualWorkspacesUsf: true,
    spaceTypeAllocationSubtotalUsf: true,
    headcountUsf: true,
    seatCountUsf: true,
    deskSharingRatio: true,
    usfBreakdown: true,
    meetingSeatRatio: true,
    programSummaryReport: true,
    workpoints: true,
    seatCountUsfWithWorkpoints: true,
    deskSharingWithWorkpoints: true,
    alternativeWorkpointsBreakdown: true,
    categoryUsfAndSeatMix: [
      INDIVIDUAL_WORKSPACES_CATEGORY,
      MEETING_SPACES_CATEGORY,
      AMENITY_SPACES_CATEGORY,
      SUPPORT_SPACES_CATEGORY,
    ].reduce(
      (categoryMap, category) => {
        return {
          ...categoryMap,
          [category]: {
            usfAndSeatMix: true,
            usfMix: true,
            seatMix: true,
            usfMixAndRatios: true,
            ratios: true,
          },
        };
      },
      {} as Record<
        string,
        {
          usfAndSeatMix: boolean;
          usfMix: boolean;
          seatMix: boolean;
          usfMixAndRatios: boolean;
          ratios: boolean;
        }
      >
    ),
  });

  return {
    visibleCards,
    setVisibleCards,
  };
};
